module.exports = __webpack_public_path__ + "img/DE06077.6c99827d.png";